import { IPlainCardProps, IStackItemStyles, getTheme } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPText } from 'baseComponents';
import { IPHoverCard, IPHoverCardType } from 'baseComponents/HoverCard/IPHoverCard';
import { IPStack } from 'baseComponents/Stack/IPStack';
import KanbanCardTaskGenericWithState from 'components/Kanban/Cards/KanbanCardTaskGenericWithState';
import Task from 'models/tasks/task';
import { useContext } from 'react';
import { toLocaleDateShortNoYear } from 'utils/datetime';
import { TaskViewScheduleLevel } from './TasksView';

interface ITaskDateLinkWithHoverCardProps {
  task: Task;
  level: TaskViewScheduleLevel;
  onTaskClick: (task: Task) => void;
}

export const TaskDateLinkWithHoverCard = (props: ITaskDateLinkWithHoverCardProps) => {
  const appContext = useContext(AppContext);
  const theme = getTheme();

  const onRenderCompactCardSingle = (item: Task): JSX.Element => {
    return (
      <IPStack styles={{ root: { width: 210, borderRadius: '3px', margin: 3 } }}>
        <KanbanCardTaskGenericWithState
          key={item.taskId.toString()}
          task={item}
          onClick={() => props.onTaskClick(item)}
        />
      </IPStack>
    );
  };

  const plainCardProps: IPlainCardProps = {
    onRenderPlainCard: onRenderCompactCardSingle,
    renderData: props.task,
  };

  const getDayLinkStyleProps = (): IStackItemStyles => {
    const backgroundColor = props.task.getBackgroundColor(appContext.useDarkMode, appContext.globalDataCache);

    return {
      root: {
        background: backgroundColor,
        color: appContext.useDarkMode ? theme.palette.themeLight : theme.palette.themeSecondary,
        height: 22,
        width: props.level === TaskViewScheduleLevel.Month ? 30 : 70,
        borderRadius: 4,
        borderColor: theme.palette.themeSecondary,
        cursor: 'pointer',
      },
    };
  };

  //
  // Main render
  //
  let text: string = '';
  switch (props.level) {
    case TaskViewScheduleLevel.Month:
      text = props.task.startDateTime.getDate().toString();
      break;
    case TaskViewScheduleLevel.Quarter:
    case TaskViewScheduleLevel.Year:
      text = toLocaleDateShortNoYear(props.task.startDateTime);
      break;
  }

  return (
    <IPHoverCard
      cardOpenDelay={300}
      type={IPHoverCardType.plain}
      plainCardProps={plainCardProps}
      instantOpenOnClick={false}
    >
      <IPStack.Item
        styles={getDayLinkStyleProps()}
        onClick={() => {
          props.onTaskClick(props.task);
        }}
      >
        <IPStack horizontalAlign="center" verticalAlign="center">
          <IPText variant="mediumPlus">{text}</IPText>
        </IPStack>
      </IPStack.Item>
    </IPHoverCard>
  );
};
